export interface TimerScheduledDispatch
{
    time: number
    func: () => void,
    removeme?: boolean
}

export class Timer
{
    public time = 0;
    public schedule: TimerScheduledDispatch[] = [];

    public clear(): void
    {
        this.time = 0;
        this.schedule = [];
    }

    public step(delta: number): void
    {
        this.time += delta;

        let i = this.schedule.length;

        while (i--)
        {
            const item = this.schedule[i];

            // PATCH A BUG - Something might be really wrong if that happens. To investigate.
            if (!item)
            {
                this.schedule.splice(i, 1);
                continue;
            }

            if (this.time >= item.time && !item.removeme)
            {
                item.func();
                item.removeme = true;
            }

            if (item.removeme)
            {
                this.schedule.splice(i, 1);
            }
        }
    }

    public dispatchAfter(time: number, func: () => void): TimerScheduledDispatch
    {
        const item = { time: this.time + time, func };

        this.schedule.push(item);

        return item;
    }

    public removeScheduledItem(item: TimerScheduledDispatch): boolean
    {
        const index = this.schedule.indexOf(item);

        if (index >= 0)
        {
            item.removeme = true;

            return true;
        }

        return false;
    }
}
